import React from 'react';

import HasData from './HasData';

const HasCommunity = props => {
    const {eventId, children, to} = props;

    return (
        <HasData path={`events[${eventId}]`} to={to}>
            <HasData path={`events[${eventId}].event.loaded`} errorMessage={`Community ${eventId} is not loaded!`}>
                <HasData path={`events[${eventId}].event._isCommunity`} warningMessage={`Event ${eventId} is not a community`}>
                    {children}
                </HasData>
            </HasData>
        </HasData>
    );
};

export default HasCommunity;
